import _sfc_main from "./TypesenseSearch.vue2.js";
import _export_sfc from "../../_virtual/_plugin-vue_export-helper.js";
const TypesenseSearch = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-954870d7"]]);
export {
  TypesenseSearch as default
};
//# sourceMappingURL=TypesenseSearch.vue.js.map
